export const APP_VERSION = "0.88+";
export const API_ENDPOINT_BASE_URL =  process.env.REACT_APP_API_ENDPOINT_BASE_URL;
export const API_ENDPOINT_BASE_URL11 = "https://stagingui.knowlarity.com:85";
export const API_ENDPOINT_BASE_URL22 = "https://srbetadapi.knowlarity.com";
export const API_ENDPOINT_BASE_URL33 = "https://sr-ui-development.knowlarity.com";
export const API_ENDPOINT_BASE_URL_1 = process.env.REACT_APP_API_ENDPOINT_BASE_URL_1;
export const API_ENDPOINT_BASE_URL_2 = process.env.REACT_APP_API_ENDPOINT_BASE_URL_2;
export const TICKER_API_ENDPOINT_BASE_URL = API_ENDPOINT_BASE_URL;
export const API_ENDPOINTS = { 
  base_url: API_ENDPOINT_BASE_URL,
  sso_login: API_ENDPOINT_BASE_URL + "/vr/sso_login/",
  login: API_ENDPOINT_BASE_URL + "/vr/sr_login/",
  loginSocial: API_ENDPOINT_BASE_URL + "/vr/social_login/",
  forgotPassword: API_ENDPOINT_BASE_URL + "/vr/forgot-password/",
  resetPassword: API_ENDPOINT_BASE_URL + "/vr/reset-password/",
  changePassword: API_ENDPOINT_BASE_URL + "/newsr/api/v1/user/change_password/",
  userDetail: API_ENDPOINT_BASE_URL + "/newsr/details/",
  userPlans: API_ENDPOINT_BASE_URL + "/newsr/api/v1/userplans/",
  userSolutions: API_ENDPOINT_BASE_URL + "/newsr/solution-type/",
  register: API_ENDPOINT_BASE_URL + "/auth/register",
  logout: API_ENDPOINT_BASE_URL + "/auth/logout",
  termsCondition: API_ENDPOINT_BASE_URL + "/newsr/api/v1/user/agreement_content/",
  getCallSummary: API_ENDPOINT_BASE_URL + "/newsr/user_call_summary/",
  getCallConnectivity:
    API_ENDPOINT_BASE_URL + "/newsr/call_connectivity_graph/",
  getPerformanceCallPickupTime:
    API_ENDPOINT_BASE_URL + "/newsr/agents_performance/",
  getPerformanceCallConnectivity:
    API_ENDPOINT_BASE_URL + "/newsr/agents_connectivity_performance/",

  getAgentsActivity: API_ENDPOINT_BASE_URL_1 + "/new/",
  getAgentDetails: API_ENDPOINT_BASE_URL + "/newsr/agents_activity/",
  getAgentFollowupsdd: API_ENDPOINT_BASE_URL + "/newsr/api/v1/customer/",
  getAgentFollowups:
    API_ENDPOINT_BASE_URL + "/newsr/api/v1/customer_followup_details/",
  getAgentCallInsights: API_ENDPOINT_BASE_URL + "/newsr/agents_insights/",
  getSupervisorCallInsights:
    API_ENDPOINT_BASE_URL + "/newsr/supervisor_insights/",
  getAgentsActivities: API_ENDPOINT_BASE_URL + "/newsr/agents_activity/",
  getAgentsQueueInfo:
    API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/queue_info/",
  getAgentInsightsDownload:
    API_ENDPOINT_BASE_URL + "/newsr/agent-insights-download",
  getAgentsActivityDownload:
    API_ENDPOINT_BASE_URL + "/newsr/agent-activity-download",
  getFeedbackQuestionSet: API_ENDPOINT_BASE_URL + "/newsr/feedback_questions/",
  feedbackSubmission: API_ENDPOINT_BASE_URL + "/newsr/submit_feedback/",
  getAgentsListingsForAdmin: API_ENDPOINT_BASE_URL + "/newsr/api/v1/agent/",
  getAdminAgentsFollowups:
    API_ENDPOINT_BASE_URL + "/newsr/api/v1/customer_followup_details/",
  getReports: API_ENDPOINT_BASE_URL + "/sr_reports/reports/",
  getSubscribedReports: API_ENDPOINT_BASE_URL + "/sr_reports/subscriptions/",
  getReportsAgents: API_ENDPOINT_BASE_URL + "/sr_reports/myagents/",
  getReportCategories: API_ENDPOINT_BASE_URL + "/sr_reports/categories/",
  getCallMonitoringAgentStatus:
    API_ENDPOINT_BASE_URL + "/newsr/agent_call_monitoring/",
  getCallMonitoringAgentsStatusOnBreakDetails:
    API_ENDPOINT_BASE_URL + "/newsr/agent_on_break_details/",
  getTotalAgentsList: API_ENDPOINT_BASE_URL + "/newsr/api/v1/agent/",
  getCustomerName: API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/customer_name/",
  getQueueMonitoringDetails:
    API_ENDPOINT_BASE_URL + "/newsr/queue_monitoring_details/",
  getQueueWaitTimeDetails:
    API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/get_wait_times/",
  getSmsLogs: API_ENDPOINT_BASE_URL + "/newsr/api/v1/smslogs/",
  getCallLogs: API_ENDPOINT_BASE_URL + "/newsr/api/v1/call_records/",
  getCallLogs2:
    "https://kzk993y2ug.execute-api.ap-southeast-1.amazonaws.com/Staging/v1/mock-call-log",
  getCrm: API_ENDPOINT_BASE_URL + "/newsr/api/v1/customer/",
  getCrmdd: API_ENDPOINT_BASE_URL + "/newsr/api/v1/customer_followup_details/",
  getDispositions: API_ENDPOINT_BASE_URL + "/newsr/api/v1/disposition/",
  addSMSNote: API_ENDPOINT_BASE_URL + "/newsr/api/v1/smslogs/",
  getAgentNumbers: TICKER_API_ENDPOINT_BASE_URL + "/newsr/api/v1/c2cagent/",
  getCallIDNumbers: TICKER_API_ENDPOINT_BASE_URL + "/newsr/callernum/",
  callApi: TICKER_API_ENDPOINT_BASE_URL + "/newsr/api/v1/click2call/",
  getQueueName:
    API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/get_cc_queue_name/",

  getAgentInsightsDetails:
    API_ENDPOINT_BASE_URL + "/newsr/agent_insights_details/",
  getAgentInsightsHandelingTime:
    API_ENDPOINT_BASE_URL + "/newsr/agent_handling_time/",
  getAgentInboundDetails:
    API_ENDPOINT_BASE_URL + "/newsr/hourly_agent_insights/",
  getAsyncDownloadCallLogsAnalytics:
    API_ENDPOINT_BASE_URL + "/newsr/api/v1/async_new_sr_logs/",
  getAgentsActivityAggregate:
    API_ENDPOINT_BASE_URL + "/newsr/agents_activity_aggregate/",
  getDownloadReports: API_ENDPOINT_BASE_URL + "/newsr/download_reports/",

  liveCallsActionCallBarge:
    API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/call_barge/",

  getAsyncDownloadAgentAnalytics:
    API_ENDPOINT_BASE_URL + "/newsr/api/v1/async_new_sr_logs/",
  getDispositionDetails:
    API_ENDPOINT_BASE_URL + "/newsr/api/v1/dispositiongroups/",
  getDispositionDetailsById:
    API_ENDPOINT_BASE_URL + "/newsr/api/v1/disposition/",

  getPhonebookDetails: API_ENDPOINT_BASE_URL + "/newsr/api/v1/obd_phonebook/",
  getHookapiDetails: API_ENDPOINT_BASE_URL + "/newsr/api/v1/hookapis/",
  createHookApi: API_ENDPOINT_BASE_URL + "/newsr/api/v1/hookapis/",
  updateHookApi: API_ENDPOINT_BASE_URL + "/newsr/api/v1/hookapis/",
  deleteHookApi: API_ENDPOINT_BASE_URL + "/newsr/api/v1/hookapis/",
  downloadDNDStatus: API_ENDPOINT_BASE_URL + "/newsr/download_dnd_status/",
  downloadNumberStatus:
    API_ENDPOINT_BASE_URL + "/newsr/download_invalid_status/",
  deletePhonebook: API_ENDPOINT_BASE_URL + "/newsr/delete_phonebook/",
  deleteDispositiongroups:
    API_ENDPOINT_BASE_URL + "/newsr/api/v1/dispositiongroups/",
  deleteSubDispositionItem:
    API_ENDPOINT_BASE_URL + "/newsr/api/v1/disposition/",
  makeDispositionApi:
    API_ENDPOINT_BASE_URL + "/newsr/api/v1/create_disposition/",
  getstickyAgentDetails: API_ENDPOINT_BASE_URL + "/newsr/api/v1/c2cagent/",
  getAgentMappedData:
    API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/get_sticky_mapping/",
  deleteStickyAgent:
    API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/delete_sticky_mapping/",
  getQueueDetails: API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/api/v1/queue/",
  uploadPhonebook: API_ENDPOINT_BASE_URL + "/newsr/phonebookupload",

  getTemplateListing: API_ENDPOINT_BASE_URL + "/newsr/api/v1/template/",
  deleteTemplate: API_ENDPOINT_BASE_URL + "/newsr/api/v1/template/",
  getSenderIdData: API_ENDPOINT_BASE_URL + "/newsr/api/v1/sms_sender_id/",
  getNdndcCountDetails: API_ENDPOINT_BASE_URL + "/newsr/ndnc_count",
  getSubscriberMulti: API_ENDPOINT_BASE_URL + "/sr_reports/subscription_multi/",
  getAgentSettingsListing: API_ENDPOINT_BASE_URL + "/newsr/api/v1/agent/",
  updateAgentSettingsStatus: API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/update_property/",
  getAgentsQueueMappings: API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/api/v1/tier/",
  getAllQueueMappingsForAgent: API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/api/v1/queue/",
  callPatchToUpdateCallGroup: API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/api/v1/tier/",
  deleteAgentsfromAgentSettings: API_ENDPOINT_BASE_URL + "/newsr/api/v1/agent/",
  getLastSavedCountryCode: API_ENDPOINT_BASE_URL + "/newsr/ajax_last_saved/", //ajax_set_last_saved/
  getLastSavedCountryCodeSet: API_ENDPOINT_BASE_URL + "/newsr/ajax_set_last_saved/",

  getTtsSounds: API_ENDPOINT_BASE_URL + "/newsr/api/v1/usersounds/",
  convertTextToSpeech: API_ENDPOINT_BASE_URL + "/newsr/convert_tts",
  uploadTTS: API_ENDPOINT_BASE_URL+ "/newsr/upload_tts",
  uploadSound: API_ENDPOINT_BASE_URL   + "/newsr/soundupload",
  multiSoundUpload: API_ENDPOINT_BASE_URL   + "/newsr/multisoundupload",
  deleteSound: API_ENDPOINT_BASE_URL + "/newsr/api/v1/usersounds/",
  getCustomBreaks: API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/custom_break/",
  updateAccountStatus:API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/update_property/",
  getBulkAgentDownloads: API_ENDPOINT_BASE_URL + "/newsr/bulk_agent_operation/",
  getUserSettings: API_ENDPOINT_BASE_URL + "/newsr/api/v1/usersettings/",
  addNewAgent: API_ENDPOINT_BASE_URL + "/newsr/api/v1/agent/",
  bulkUploadAgents: API_ENDPOINT_BASE_URL + "/newsr/bulk_agent_operation/",
  getQueueMappingHistory: API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/get_tier_logs/",
  getAgentSettingCSVLogs: API_ENDPOINT_BASE_URL + "/newsr/bulk_agent_operation/",
  leadAssignmentApi: API_ENDPOINT_BASE_URL + '/Basic/v1/account/contacts/',
  leadBulkUpload: API_ENDPOINT_BASE_URL + '/newsr/api/v1/csv/upload/',
  bulkDownloadCustomers: API_ENDPOINT_BASE_URL + '/newsr/api/v1/contacts_export/',
  getAutoAnswer: API_ENDPOINT_BASE_URL+ '/newsr/auto_answer/',
  getDeveloperKey: API_ENDPOINT_BASE_URL + '/newsr/api/v1/developer/keys/',
  getSoundLists: API_ENDPOINT_BASE_URL + "/newsr/api/v1/sound/",
  getAgentsList:  API_ENDPOINT_BASE_URL +"/newsr/sr_callcenter/api/v1/tier/",
  agentsMappingToQueue:  API_ENDPOINT_BASE_URL +"/newsr/sr_callcenter/api/v1/tier/",
  resetAgentStatus: API_ENDPOINT_BASE_URL + "/newsr/sr_callcenter/reset_agent_status/"
};

export const API_CONSTANTS = {
  AGENTS_INSIGHTS_PAGE_LIMIT: 5,
  AGENTS_ACTIVITY_PAGE_LIMIT: 5,
  SUPERVISOR_INSIGHTS_PAGE_LIMIT: 5,
  AGENT_FOLLOWUP_PAGE_LIMIT: 5,
  LIVE_INTERACTIONS_CALLS_PAGE_LIMIT: 5,
  AGENT_STATUS_TOTAL_AGENTS_PAGE_LIMIT: 10,
  AGENTS_CALL_LOGS_LIMIT: 5,
};

export const API_PUBLIC_KEY =
  "-----BEGIN PUBLIC KEY-----\
                               MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDBPNh150iqmU58BIPZcFNTmfTg\
                               TLKz0UttceY4HcrwemFAJ3tEog5ohjXxAhj/1fjhzBob7SmG1gsDMbog+VSJwni/\
                               onmqutz7mqrv7NZno6ctdBGwQ3BBmPqzZ6trJvwE8pihimTUqglqRciGd9A4G9ee\
                               dQGgP5coi4RN3ubMkwIDAQAB\
                               -----END PUBLIC KEY-----";

export const APP_INFOGRAPICS = [
  {
    id: "carousel_item_1",
    image: "/media/sr/misc/lct.svg",
    title: "Inforgraphics_title_carousel_item_1",
    sub_title: "Inforgraphics_description_carousel_item_1",
    redirect_url: "https://www.knowlarity.com/call-center-solutions/",
  },
  {
    id: "carousel_item_2",
    image: "/media/sr/misc/asr.svg",
    title: "Inforgraphics_title_carousel_item_2",
    sub_title: "Inforgraphics_description_carousel_item_2",
    redirect_url: "https://www.knowlarity.com/speech-analytics/",
  },
  // {
  //   id: "carousel_item_3",
  //   image: "/media/sr/misc/video-conference.svg",
  //   title: "Inforgraphics_title_carousel_item_3",
  //   sub_title: "Inforgraphics_description_carousel_item_3",
  //   redirect_url: "https://www.knowlarity.com/video/video-platform",
  // },
];

export const APP_CONSTANT = {
  POWERED_BY_LINK: "http://www.knowlarity.com/",
  SR_POLICY_LINK: "https://sr.knowlarity.com/newsr/policy/",
  SR_TERMS_LINK: "https://sr.knowlarity.com/newsr/tnc/",
  COPYRIGHT_YEAR: "2009-2022",
};

export const FILTER_TYPES = {
  dates_filter: "dates_filter",
};

export const DATE_SETTINGS = {
  filters: {
    last_30_minutes: { code: "last_30_minutes" },
    last_1_hour: { code: "last_1_hour" },
    current_week: { code: "current_week" },
    last_7_days: { code: "last_7_days" },
    current_month: { code: "current_month" },
    last_month: { code: "last_month" },
    custom_date: { code: "custom_date" },
    today: { code: "today" },
    yesterday: { code: "yesterday" },
  },
};

//API Version
export const REACT_APP_API_VERSION = "2";

export const API_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DISPLAY_DATE_FORMAT = "YYYY-MM-DD HH:mm";
export const DISPLAY_DATE_FORMAT_2 = "DD MMM YYYY, HH:mm:ss A";
export const DISPLAY_DATE_FORMAT_3 = "DD MMM YYYY";
export const DISPLAY_DATE_FORMAT_4 = "DD MMM YYYY HH:mm";
export const DISPLAY_TIME_FORMAT_1 = "HH:mm:ss a";
export const FOLLOWUP_DATE_FORMAT = "DD MMM yyyy, hh:mm a";
export const FOLLOWUP_DATE_FORMAT_ON = "MMM DD, yyyy [at] hh:mm a";
export const FNS_FOLLOWUP_DATE_FORMAT = "dd MMM yyyy, hh:mm a";
export const FOLLOW_UP_FILTER_FORMAT = "YYYY-MM-DD HH:mm:ssZ";

export const REACT_APP_MOCK_DATA_ENABLED = false;

export const LogConfigs = {
  "[AgentsActivity][WS]": { TAG: "[AgentsActivity][WS]" },
};

export const graphColorCodes = {
  red: "#e12c40",
  green: "#1bae96",
  orange: "#ffa800",
  grey: "#b5b5c3",
  redOrange: "#e07e5f",
  blue: "#558fed",
  yellow: "#ffef39",
};
